import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { connect } from "react-redux";
import AppTabs from "../Common/Tabs/AppTabs";
import {
  getInAppNotificationPermission,
  IN_APP_NOTIFICATION_MODULE_NAME,
  ASSIGNMENT_ACCESS_DENIED_MESSAGE,
  inAppPageTitleSx,
  inAppTabPanelSx,
} from "../../constants/inAppNotificationConstant";
import { mapNotificationPageStateToProps } from "./notificationPageAuth";
import NotificationsTab from "./NotificationsTab";
import UserAssignmentsTab from "./UserAssignmentsTab";
import EmptyState from "../Common/EmptyState/EmptyState";

const MAIN_TABS = [{ label: "Notifications" }, { label: "User Assignments" }];

const InAppNotificationManagement = ({ userRoles = [], userLevel = 0 }) => {
  const [activeTab, setActiveTab] = useState(0);

  const canConfigure = getInAppNotificationPermission(
    userRoles,
    "configureUsers",
    userLevel,
  );

  return (
    <Box sx={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}>
        <Typography variant="h5" sx={inAppPageTitleSx}>
          {IN_APP_NOTIFICATION_MODULE_NAME}
        </Typography>

        <AppTabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          tabs={MAIN_TABS}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          tabMinWidth="auto"
          appearance="neutral"
        />

        <Box sx={inAppTabPanelSx}>
          {activeTab === 0 && (
            <NotificationsTab userRoles={userRoles} userLevel={userLevel} />
          )}
          {activeTab === 1 && canConfigure && (
            <UserAssignmentsTab userRoles={userRoles} userLevel={userLevel} />
          )}
          {activeTab === 1 && !canConfigure && (
            <EmptyState
              minHeight="40vh"
              message={ASSIGNMENT_ACCESS_DENIED_MESSAGE}
            />
          )}
        </Box>
      </Box>
  );
};

export default connect(mapNotificationPageStateToProps)(InAppNotificationManagement);
